module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABHNCSVQICAgIfAhkiAAAAO1JREFUKJGVkuFtgzAUhD/bGaQjQFjA2cQggtgCe4sWtcibhAxQtRt0EiA/gpFLSKI8yX/su3t3z0+wKlPWmmFoABBCAxbAd62LcSomJMn+j3F8QymHlGf/9ZEnaaYBkjTrkzTj9+f7DCAATFE1gEXKg/9879cutjByvr8hmaKaYqLvWoeUhxBDBqV7nf6RZ4wpay2fYG9LKccwNDvA+q4Vr/KFyY8nlHJbVlc5bfgSU1TT7pHqlpMwExk8v2r1qpIfT6as9VNcUTXB/nWqSjnG8SF5frPzYcmwbEa0m4tQiBIN8V54AMs09WtCqAv3CW2LeW16yQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Stouditime.png
// module id = 6YGU
// module chunks = 1